import Button from 'components/Button';
import Header from 'components/Header';
import Layout from 'containers/Layout';
import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import Meta from 'utils/Meta';
import RichText from 'utils/RichText';
import { sizes, colors, helpers, media, width } from 'styles/variables';
import radio_0 from '../../static/radio_0.svg';
import radio_1 from '../../static/radio_1.svg';
import checkbox_0 from '../../static/checkbox_0.svg';
import checkbox_1 from '../../static/checkbox_1.svg';
import animateScrollTo from 'animated-scroll-to';
import { navigate } from 'gatsby';
import firebase from 'gatsby-plugin-firebase';

const CancelForm = styled.div`
	h1 {
		margin-bottom: ${sizes[3]};
		font-size: 2.5rem;
	}
	width: 100%;
	max-width: 500px;
	height: auto;
	margin: ${sizes[3]} auto;
	ul {
		margin-bottom: ${sizes[3]};
		> strong {
			font-size: 1.1rem;
			margin: ${sizes[3]} 0 ${sizes[1]};
		}
		li {
			margin-bottom: ${sizes[1]};
		}
	}
`;

const Form = styled.form`
	&.--active {
		display: grid;
	}
	&.--inactive {
		display: none;
	}
	width: 100%;
	max-width: ${width.max}px;
	margin: 0 auto;
	padding: ${sizes[3]};
	grid-auto-flow: row;
	grid-gap: ${sizes[2]};
	label,
	.label {
		position: relative;
		cursor: pointer;
		background: ${colors.background[0]};
		&[type='multichoice'],
		&[type='singlechoice'] {
			display: grid;
			grid-template-columns: auto 1fr;
			align-items: center;
			grid-gap: ${sizes[1]};
			padding: ${sizes[2]};
			border-radius: ${sizes[0]};
			${helpers.shadow};
			border: 3px solid ${colors.background[0]};
			&.--active {
				border: 3px solid ${colors.teal.base};
			}
			div:first-of-type:before {
				content: '';
				display: block;
				width: 20px;
				height: 20px;
				background: center no-repeat;
				background-size: contain;
			}
		}
		&[type='multichoice'] {
			div:first-of-type:before {
				background-image: url(${checkbox_0});
			}
			&.--active div:first-of-type:before {
				background-image: url(${checkbox_1});
			}
		}
		&[type='singlechoice'] {
			div:first-of-type:before {
				background-image: url(${radio_0});
			}
			&.--active div:first-of-type:before {
				background-image: url(${radio_1});
			}
		}
		&[type='measurements_weight'],
		&[type='measurements_other'],
		&[type='text'] {
			input {
				padding: ${sizes[1]};
				width: 100%;
				text-align: left;
				border: 0;
				outline: none;
				border-bottom: 1px solid ${colors.background[2]};
			}
		}
		&[type='text'] {
			&[item-type='checkbox'] {
				display: grid;
				grid-template-columns: auto 1fr;
				align-items: center;
				grid-gap: ${sizes[1]};
				padding-top: ${sizes[1]};
				small {
					line-height: 1.5;
				}
				a {
					text-decoration: underline;
				}
				div:first-of-type:before {
					content: '';
					display: block;
					width: 20px;
					height: 20px;
					background: center no-repeat;
					background-size: contain;
					background-image: url(${checkbox_0});
				}
				&.--active {
					div:first-of-type:before {
						background-image: url(${checkbox_1});
					}
				}
			}
		}
		strong,
		small {
			display: block;
		}
	}
	input[type='checkbox'],
	input[type='radio'] {
		display: none;
	}
	input[type='number']::-webkit-inner-spin-button,
	input[type='number']::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	.imperialHeight {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: ${sizes[2]};
		> div {
			position: relative;
		}
	}
`;
const Error = styled.div`
	padding: ${sizes[2]};
	margin-bottom: ${sizes[2]};
	border-radius: ${sizes[0]};
	background: ${colors.red.base};
	color: ${colors.background[0]};
	display: block;
	width: 100%;
	font-size: 0.9rem;
	line-height: 150%;
`;
const Reset = styled.div`
	width: 100%;
	font-size: 0.8rem;
	color: ${colors.foreground[2]};
	text-decoration: underline;
	text-align: center;
	padding: ${sizes[2]};
	cursor: pointer;
	&:hover {
		text-decoration: none;
	}
`;
export default props => {
	const [meta] = useState(require(`data/meta`));
	const [btnText, setBtnText] = useState(false);
	const [error, setError] = useState(false);
	const [user, setUser] = useState(false);

	useEffect(() => {
		firebase.auth().onAuthStateChanged(function(user) {
			if (user) {
				setUser(true);
				navigate(props.pageContext.redirect);
			} else {
				setUser(true);
			}
		});
	}, []);

	const handleResetPassword = e => {
		setError(false);
		const form = new FormData(e.target.closest('form'));
		firebase
			.auth()
			.sendPasswordResetEmail(form.get('email'))
			.then(function() {
				createError(`Password reset email was sent to ${form.get('email')}`);
			})
			.catch(function(error) {
				createError(error.message);
			});
	};

	const handleLogin = e => {
		setError(false);
		setBtnText('Loading...');
		const form = new FormData(e.target.closest('form'));
		firebase
			.auth()
			.signInWithEmailAndPassword(form.get('email'), form.get('password'))
			.then(user => {
				window._uid = user.user.uid;
				firebase
					.firestore()
					.collection('users')
					.doc(window._uid)
					.get()
					.then(docRef => {
						let doc = docRef.data();
						setBtnText(false);
						// axios.post('/.netlify/functions/cancel', {
						// 	data: {
						// 		url: window.location.href.split('?')[0],
						// 		firebase: {
						// 			pid: doc.PAYPAL_SUBSCRIPTION_ID,
						// 			sid: doc.STRIPE_CHECKOUT_SESSION_ID,
						// 			json: doc.json,
						// 		},
						// 	},
						// });
					});
			})
			.catch(err => {
				createError(err.message);
				setBtnText(false);
			});
	};

	const createError = message => {
		setError(message);
		animateScrollTo(document.querySelector('#error'));
	};

	return (
		<>
			<Meta />
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						'@context': 'http://schema.org',
						'@type': 'WebPage',
						url: meta.domain,
						name: meta.title,
						description: meta.description,
					})}
				</script>
			</Helmet>
			<Layout>
				<Header />
				<CancelForm>
					<Form>
						<h1>Login to your Reshape profile</h1>
						{error && <Error id="error">{error}</Error>}
						{[
							{
								name: 'login',
								type: 'text',
								title: false,
								data: [
									{ name: 'email', title: 'Email address', value: '' },
									{ name: 'password', title: 'Password', value: '' },
								],
							},
						].map((group, index) => {
							return (
								<ul key={index}>
									{group.title && <strong>{group.title}</strong>}
									<ul>
										{group.data.map((item, index) => {
											switch (group.type) {
												case 'text':
													return (
														<li key={index}>
															<label type={group.type} key={index}>
																<input
																	name={item.name}
																	type={item.name}
																	defaultValue={item.value}
																	placeholder={item.title}
																/>
															</label>
														</li>
													);
												default:
													return <></>;
											}
										})}
									</ul>
								</ul>
							);
						})}
						<div onClick={e => handleLogin(e)}>
							<Button title={btnText || 'Login'} type={1} hue={'pink'} />
						</div>
						<Reset onClick={handleResetPassword}>Reset My Password</Reset>
					</Form>
				</CancelForm>
			</Layout>
		</>
	);
};
